import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary } = theme.palette;

  return {
    preferencesProperty: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 6
    },
    propertyTitle: {
      color: primary.main
    },
    wrapTextField: {
      maxWidth: 125
    },
    input: {
      padding: "0 12px 0",
      height: 32,
      width: 125,
      fontSize: 12,
      borderRadius: 3
    }
  };
});
